module.exports = __webpack_public_path__ + "static/media/doclad8.91a5315d.pdf";